import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  Button,
  CardComponent,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';

interface FiscalControlDocumentsTabProps {
  tableTitle: string;
  rowData: string[][];
  columns: Columns[];
  handleAddNewDocument: () => void;
}

const useStyles = makeStyles()({
  root: {
    marginTop: '1rem',
  },
});

const FiscalControlDocumentsTab: React.FC<FiscalControlDocumentsTabProps> = ({
  tableTitle,
  rowData,
  columns,
  handleAddNewDocument,
}) => {
  const { classes } = useStyles();
  return (
    <CardComponent
      title={tableTitle}
      body={
        <Grid className={classes.root}>
          <BasicTable
            columns={columns}
            rowsData={rowData}
            displayType="row"
            isFullTable
          />
        </Grid>
      }
      mainGridStyles={{ width: '100%', marginTop: '1rem' }}
      topRightItem={
        <Button
          label="+ Add New Document"
          width="190px"
          onClick={handleAddNewDocument}
        />
      }
    />
  );
};

export default FiscalControlDocumentsTab;
